import React from 'react';
import Icon from '../../../components/AppIcon';

const ActivityFeed = ({ activities }) => {
  const getActivityIcon = (type) => {
    switch (type) {
      case 'search': return 'Search';
      case 'save': return 'Heart';
      case 'view': return 'Eye';
      case 'tour': return 'Calendar';
      case 'alert': return 'Bell';
      case 'contact': return 'MessageCircle';
      default: return 'Activity';
    }
  };

  const getActivityColor = (type) => {
    switch (type) {
      case 'search': return 'text-blue-600';
      case 'save': return 'text-red-500';
      case 'view': return 'text-green-600';
      case 'tour': return 'text-purple-600';
      case 'alert': return 'text-orange-500';
      case 'contact': return 'text-indigo-600';
      default: return 'text-muted-foreground';
    }
  };

  if (activities?.length === 0) {
    return (
      <div className="bg-card rounded-lg border border-border p-6">
        <h2 className="text-lg font-semibold text-foreground mb-4">Recent Activity</h2>
        <div className="text-center py-8">
          <div className="w-16 h-16 bg-muted rounded-full flex items-center justify-center mx-auto mb-4">
            <Icon name="Activity" size={24} className="text-muted-foreground" />
          </div>
          <p className="text-muted-foreground">No recent activity</p>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-card rounded-lg border border-border p-6">
      <h2 className="text-lg font-semibold text-foreground mb-4">Recent Activity</h2>
      <div className="space-y-4">
        {activities?.slice(0, 8)?.map((activity) => (
          <div key={activity?.id} className="flex items-start space-x-3">
            <div className={`w-8 h-8 rounded-full bg-muted flex items-center justify-center flex-shrink-0 ${getActivityColor(activity?.type)}`}>
              <Icon name={getActivityIcon(activity?.type)} size={14} />
            </div>
            
            <div className="flex-1 min-w-0">
              <p className="text-sm text-foreground">
                <span className="font-medium">{activity?.action}</span>
                {activity?.propertyTitle && (
                  <span className="text-muted-foreground">
                    {' '}{activity?.propertyTitle}
                  </span>
                )}
              </p>
              {activity?.location && (
                <p className="text-xs text-muted-foreground mt-1">
                  <Icon name="MapPin" size={12} className="inline mr-1" />
                  {activity?.location}
                </p>
              )}
              <p className="text-xs text-muted-foreground mt-1">
                {activity?.timestamp}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ActivityFeed;